import axios from "@/plugins/axios";
import fetchModels from "@/mixin/store/api/fetchModels";

export default {
    actions: {
        fetchSaleServiceStatAll(context) {
            if (context.state.saleServiceStatAll.isNeedFetch) {
                return fetchModels(context, 'sale_service_yearlies/all', null, 'updateSaleServiceStatAll')
            }
        },
        fetchSaleServiceYearlyStat(context, searchItem) {
            let url = "sale_service_yearlies?page="  + searchItem.page

            if (!context.state.saleServiceYearlyStat.isNeedFetch && !searchItem.isNeedFetch) {
                return
            }

            if (searchItem.byAmount) {
                url = url + '&order[amount]=desc'
            } else {
                url = url + '&order[incomeAmount]=desc'
            }

            if (searchItem.before) {
                url = url + '&date[before]=' + searchItem.before
            }

            if (searchItem.after) {
                url = url + '&date[after]=' + searchItem.after
            }

            return axios.get(url)
                .then((response) => {
                    console.log(response)

                    let data = {
                        models: response.data['hydra:member'],
                        totalItems: response.data['hydra:totalItems']
                    }

                    context.commit('updateSaleServiceYearlyStat', data)
                })
                .catch((err) => {
                    console.log(err)
                })
        },
    },
    mutations: {
        updateSaleServiceYearlyStat(state, data) {
            state.saleServiceYearlyStat = data
            state.saleServiceYearlyStat.isNeedFetch = false
        },
        updateSaleServiceStatAll(state, data) {
            state.saleServiceStatAll = data
            state.saleServiceStatAll.isNeedFetch = false
        },
    },
    state: {
        saleServiceYearlyStat: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        },
        saleServiceStatAll: {
            models: [],
            totalItems: 0,
            isNeedFetch: true
        }
    },
    getters: {
        getSaleServiceYearlyStat(state) {
            return state.saleServiceYearlyStat.models
        },
        getSaleServiceYearlyStatTotalCount(state) {
            return state.saleServiceYearlyStat.totalItems
        },
        getSaleServiceStatAll(state) {
            return state.saleServiceStatAll.models
        },
    },
}
